import { create } from "zustand";

interface IssueSelectionState {
  selectedIssueIds: string[];
  lastSelectedIssueId: string | null;
  toggleIssueSelection: (issueId: string) => void;
  selectSingleIssue: (issueId: string) => void;
  addToSelection: (issueId: string) => void;
  removeFromSelection: (issueId: string) => void;
  selectAllVisible: (issueIds: string[]) => void;
  selectAllInColumn: (issueIds: string[]) => void;
  clearSelection: () => void;
}

export const useIssueSelectionStore = create<IssueSelectionState>(
  (set, get) => ({
    selectedIssueIds: [],
    lastSelectedIssueId: null,
    toggleIssueSelection: (issueId: string) => {
      const state = get();
      const currentIndex = state.selectedIssueIds.indexOf(issueId);
      let newSelectedIssueIds = [...state.selectedIssueIds];
      let newLastSelectedIssueId = state.lastSelectedIssueId;
      if (currentIndex >= 0) {
        newSelectedIssueIds.splice(currentIndex, 1);
        if (state.lastSelectedIssueId === issueId) {
          newLastSelectedIssueId =
            state.selectedIssueIds.length > 0
              ? state.selectedIssueIds[state.selectedIssueIds.length - 1]
              : null;
        }
      } else {
        newSelectedIssueIds.push(issueId);
        newLastSelectedIssueId = issueId;
      }
      set({
        selectedIssueIds: newSelectedIssueIds,
        lastSelectedIssueId: newLastSelectedIssueId,
      });
    },
    selectSingleIssue: (issueId: string) => {
      set({ selectedIssueIds: [issueId], lastSelectedIssueId: issueId });
    },
    addToSelection: (issueId: string) => {
      const state = get();
      let newSelectedIssueIds = [...state.selectedIssueIds];
      let newLastSelectedIssueId = state.lastSelectedIssueId;
      if (!state.selectedIssueIds.includes(issueId)) {
        newSelectedIssueIds.push(issueId);
        newLastSelectedIssueId = issueId;
      }
      set({
        selectedIssueIds: newSelectedIssueIds,
        lastSelectedIssueId: newLastSelectedIssueId,
      });
    },
    removeFromSelection: (issueId: string) => {
      const state = get();
      let newSelectedIssueIds = [...state.selectedIssueIds];
      let newLastSelectedIssueId = state.lastSelectedIssueId;
      const currentIndex = state.selectedIssueIds.indexOf(issueId);
      if (currentIndex >= 0) {
        newSelectedIssueIds.splice(currentIndex, 1);
        if (state.lastSelectedIssueId === issueId) {
          newLastSelectedIssueId =
            state.selectedIssueIds.length > 0
              ? state.selectedIssueIds[state.selectedIssueIds.length - 1]
              : null;
        }
      }
      set({
        selectedIssueIds: newSelectedIssueIds,
        lastSelectedIssueId: newLastSelectedIssueId,
      });
    },
    selectAllVisible: (issueIds: string[]) => {
      set({
        selectedIssueIds: issueIds,
        lastSelectedIssueId:
          issueIds.length > 0 ? issueIds[issueIds.length - 1] : null,
      });
    },
    selectAllInColumn: (issueIds: string[]) => {
      set({
        selectedIssueIds: issueIds,
        lastSelectedIssueId:
          issueIds.length > 0 ? issueIds[issueIds.length - 1] : null,
      });
    },
    clearSelection: () => {
      set({ selectedIssueIds: [], lastSelectedIssueId: null });
    },
  })
);
